// extracted by mini-css-extract-plugin
export default {"loadBtn":"Button_loadBtn__7vPu3"};